module.exports = __webpack_public_path__ + "img/judge.535586dd.jpg";